import { Fragment } from "react";

/**
 * Maps '\n' characters to <br> tags.
 * The text can be passed as a prop or as children, prioritizing the prop.
 *
 * @param {{
 *  children?: string,
 *  text?: string
 * }} props
 *
 * @returns {JSX.Element} The text as jsx with <br> tags inserted for each newline character.
 */
const BrOnNewlineChar = ({ children, text }) => (
    <>
        {(text || children)?.split("\n")?.map((line, index) => (
            <Fragment key={index}>
                {line}
                <br />
            </Fragment>
        ))}
    </>
);

export default BrOnNewlineChar;
